module.exports = __webpack_public_path__ + "img/b3ea3face01c59e4b236725f720e8ecf.png";